import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit} from '@angular/core';
import {PositionOverviewFilter} from '../../../../domain/filter/position-overview-filter';
import {isDefined} from '../../../../commons/utils';
import {
  FilterPeriods
} from '../../insights-details-modal/position-overview-details-modal/position-overview-details-modal.component';
import {IonicModule} from '@ionic/angular';
import {DateFormatPipe} from '../../../../pipes/date-format/date-format.pipe';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-insights-dates-label',
  imports: [IonicModule, DateFormatPipe, TranslateModule],
  templateUrl: './insights-dates-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./insights-dates-label.component.scss']
})
export class InsightsDatesLabelComponent implements OnInit, OnChanges {
  @Input() positionOverviewFilter: PositionOverviewFilter;
  @Input() filterPeriods: FilterPeriods;
  @Input() backgroundGrey = false;

  shownDates: ShownDates;

  ngOnChanges(): void {
    this.calculateShownDates();
  }

  ngOnInit(): void {
    this.calculateShownDates();
  }

  private calculateShownDates(): void {
    this.shownDates = {
      settlementDateFrom: isDefined(this.positionOverviewFilter.hedgeDateFrom)
        ? new Date(this.positionOverviewFilter.hedgeDateFrom)
        : this.filterPeriods.settlementPeriod.startDate,
      settlementDateTo: isDefined(this.positionOverviewFilter.hedgeDateTo)
        ? new Date(this.positionOverviewFilter.hedgeDateTo)
        : this.filterPeriods.settlementPeriod.endDate,
      tradeDateFrom: isDefined(this.positionOverviewFilter.executionDateFrom)
        ? new Date(this.positionOverviewFilter.executionDateFrom)
        : this.filterPeriods.tradesPeriod.startDate,
      tradeDateTo: isDefined(this.positionOverviewFilter.executionDateTo)
        ? new Date(this.positionOverviewFilter.executionDateTo)
        : this.filterPeriods.tradesPeriod.endDate,
      showSettlementDates: isDefined(this.positionOverviewFilter.hedgeDateFrom)
                || isDefined(this.positionOverviewFilter.hedgeDateTo),
      showTradeDates: isDefined(this.positionOverviewFilter.executionDateFrom)
                || isDefined(this.positionOverviewFilter.executionDateTo)
    };
  }
}

export class ShownDates {
  settlementDateFrom: Date;
  settlementDateTo: Date;
  tradeDateFrom: Date;
  tradeDateTo: Date;
  showSettlementDates = false;
  showTradeDates = false;
}
